import React from 'react';
import { useState, useEffect } from 'react';
import '../classes/CourseCalendar.css';
import { configData } from "../../config";

// This month and the two after it, as { id: "2026-10", label: "October 2026" }
const calendarMonths = () => {
    const today = new Date();
    return [0, 1, 2].map((offset) => {
        const date = new Date(today.getFullYear(), today.getMonth() + offset, 1);
        return {
            id: date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0'),
            label: date.toLocaleString('en-US', { month: 'long' }) + ' ' + date.getFullYear(),
        };
    });
};

// The Courses page calendar ($$CALENDARVIEW$$): the courses starting each week,
// one month at a time, for the next 3 months.
const CourseCalendar = () => {
    const app_url = configData.APP_URL;
    const [months] = useState(calendarMonths);
    const [current, setCurrent] = useState(0);
    const [weeks, setWeeks] = useState({});

    useEffect(() => {
        const month = months[current].id;
        if (weeks[month]) return;

        const getcalendar = async () => {
            try {
                const response = await fetch(app_url + 'pages/getcoursecalendar?month=' + month, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                const responsedata = await response.json();
                if (responsedata.data?.weeks) {
                    setWeeks((loaded) => ({ ...loaded, [month]: responsedata.data.weeks }));
                }
            } catch (err) {
                console.error(err);
            }
        };
        getcalendar();
    }, [current]);

    const monthWeeks = weeks[months[current].id] || [];

    return (
        <div className="course-calendar">
            <div className="course-calendar__month">
                {months[current].label}
                {current > 0 && (
                    <button type="button" className="course-calendar__prev" onClick={() => setCurrent(current - 1)} aria-label="Previous month" />
                )}
                {current < months.length - 1 && (
                    <button type="button" className="course-calendar__next" onClick={() => setCurrent(current + 1)} aria-label="Next month" />
                )}
            </div>

            <table>
                <tbody>
                    <tr className="course-calendar__desktop-row">
                        <td className="course-calendar__week">Starts the Week Of...</td>
                        <td className="course-calendar__heading">8-Week Courses &amp; Certificates</td>
                    </tr>
                    {monthWeeks.map((week) => (
                        <tr key={week.label}>
                            <td className="course-calendar__week">
                                <span className="course-calendar__desktop">{week.label}</span>
                                <span className="course-calendar__mobile">Starts the Week of {week.label}</span>
                            </td>
                            <td className="course-calendar__courses">
                                <ul>
                                    {week.courses.map((course, idx) => (
                                        <li key={idx}>
                                            {course.link ? <a href={course.link}>{course.name}</a> : course.name}
                                        </li>
                                    ))}
                                </ul>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default CourseCalendar;
